export default __webpack_public_path__ + "static/media/ordered_list_icon_grey.3879dc5c.svg";